import Icon from '../components/Icon.vue'

Icon.register({"money-check":{"width":640,"height":512,"paths":[{"d":"M0 448C0 465.7 14.3 480 32 480H608C625.7 480 640 465.7 640 448V128H0V448zM448 240C448 231.2 455.2 224 464 224H560C568.8 224 576 231.2 576 240V272C576 280.8 568.8 288 560 288H464C455.2 288 448 280.8 448 272V240zM448 360C448 355.6 451.6 352 456 352H568C572.4 352 576 355.6 576 360V376C576 380.4 572.4 384 568 384H456C451.6 384 448 380.4 448 376V360zM64 264C64 259.6 67.6 256 72 256H376C380.4 256 384 259.6 384 264V280C384 284.4 380.4 288 376 288H72C67.6 288 64 284.4 64 280V264zM64 360C64 355.6 67.6 352 72 352H248C252.4 352 256 355.6 256 360V376C256 380.4 252.4 384 248 384H72C67.6 384 64 380.4 64 376V360zM624 32H16C7.2 32 0 39.2 0 48V96H640V48C640 39.2 632.8 32 624 32z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/money-check.js
// module id = 3I3Q
// module chunks = 0